import { NormalSelectOptions } from "@app/components/select/select.type";

export enum BookOption {
  FREE = 1,
  VIP = 2,
  PURCHASE = 3,
}

export enum OptionName {
  FREE = "Miễn phí",
  VIP = "VIP",
  PURCHASE = "Mua lẻ",
}

export const BookOptionName = Object.freeze({
  [BookOption.FREE]: OptionName.FREE,
  [BookOption.VIP]: OptionName.VIP,
  [BookOption.PURCHASE]: OptionName.PURCHASE,
});

export const BookOptions: NormalSelectOptions = [
  { label: OptionName.FREE, value: BookOption.FREE.toString() },
  { label: OptionName.VIP, value: BookOption.VIP.toString() },
  { label: OptionName.PURCHASE, value: BookOption.PURCHASE.toString() },
];

export const genreOptions: NormalSelectOptions = [
  { value: "novel", label: "Tiểu thuyết" },
  { value: "fantasy", label: "Thể loại fantasy" },
  { value: "romance", label: "Tiểu thuyết tình cảm" },
  { value: "mystery", label: "Trinh thám/kinh dị" },
  { value: "scifi", label: "Khoa học viễn tưởng" },
  { value: "historical", label: "Lịch sử" },
  { value: "literary", label: "Văn học" },
  { value: "drama", label: "Kịch tính" },
  { value: "adventure", label: "Phiêu lưu" },
  { value: "memoir", label: "Hồi ký" },
  { value: "chapter", label: "Bìa chương" },
  { value: "classic", label: "Cổ điển" }
];

export enum SortBy {
  ALL = 0,
  LATEST = 1,
  MOST_POPULAR = 2,
  OLDEST = 3,
}

export enum SortByName {
  ALL = "Tất cả",
  LATEST = "Mới nhất",
  MOST_POPULAR = "Phổ biến nhất",
  OLDEST = "Cũ nhất",
}

export const SortByOptions: NormalSelectOptions = [
  { label: SortByName.ALL, value: SortBy.ALL.toString() },
  { label: SortByName.LATEST, value: SortBy.LATEST.toString() },
  { label: SortByName.MOST_POPULAR, value: SortBy.MOST_POPULAR.toString() },
  { label: SortByName.OLDEST, value: SortBy.OLDEST.toString() },
];

export enum BookType {
  ALL = 0,
  PUBLISH = 1,
  UNPUBLISH = 2,
  DRAFT = 3,
  TRASH = 4,
}

export const BookTypeOptions: NormalSelectOptions = [
  { label: "All", value: BookType.ALL.toString() },
  { label: "Publish", value: BookType.PUBLISH.toString() },
  { label: "Unpublish", value: BookType.UNPUBLISH.toString() },
  { label: "Draft", value: BookType.DRAFT.toString() },
  { label: "Trash", value: BookType.TRASH.toString() },
];

export enum ContractStatus {
  NO_CONTRACT = 1,
  PENDING_APPROVAL = 2,
  NEED_SUPPLEMENT = 3,
  FILING_PROCESS = 4,
  COMPLETED = 5,
}

export enum ContractStatusName {
  NO_CONTRACT = "(1/5) Chưa có Phụ lục hợp đồng",
  PENDING_APPROVAL = "(2/5) Đang đợi duyệt phụ lục hợp đồng",
  NEED_SUPPLEMENT = "(3/5) Cần bổ sung lại, dẫn link",
  FILING_PROCESS = "(4/5) Đang nộp lưu chiểu, quá trình này 15 ngày",
  COMPLETED = "(5/5) Hoàn tất",
}

export const ContractStatusMap = Object.freeze({
  [ContractStatus.NO_CONTRACT]: ContractStatusName.NO_CONTRACT,
  [ContractStatus.PENDING_APPROVAL]: ContractStatusName.PENDING_APPROVAL,
  [ContractStatus.NEED_SUPPLEMENT]: ContractStatusName.NEED_SUPPLEMENT,
  [ContractStatus.FILING_PROCESS]: ContractStatusName.FILING_PROCESS,
  [ContractStatus.COMPLETED]: ContractStatusName.COMPLETED,
});

export const getContractStatusLabel = (status: number | null | undefined): string => {
  return status && ContractStatusMap[status as keyof typeof ContractStatusMap]
    ? ContractStatusMap[status as keyof typeof ContractStatusMap]
    : ContractStatusName.NO_CONTRACT;
};

export const ContractStatusList = [
  { label: ContractStatusName.NO_CONTRACT, value: ContractStatus.NO_CONTRACT },
  { label: ContractStatusName.PENDING_APPROVAL, value: ContractStatus.PENDING_APPROVAL },
  { label: ContractStatusName.NEED_SUPPLEMENT, value: ContractStatus.NEED_SUPPLEMENT },
  { label: ContractStatusName.FILING_PROCESS, value: ContractStatus.FILING_PROCESS },
  { label: ContractStatusName.COMPLETED, value: ContractStatus.COMPLETED }
];

export enum ContractRequestStatus {
  ALL = 0,
  REQUEST_APPROVAL = 1,
  NO_REQUEST = 2,
}

export enum ContractRequestStatusName {
  ALL = "Tất cả",
  REQUEST_APPROVAL = "Yêu cầu duyệt",
  NO_REQUEST = "Không yêu cầu",
}

export const ContractRequestStatusOptions: NormalSelectOptions = [
  { label: ContractRequestStatusName.ALL, value: ContractRequestStatus.ALL.toString() },
  { label: ContractRequestStatusName.REQUEST_APPROVAL, value: ContractRequestStatus.REQUEST_APPROVAL.toString() },
  { label: ContractRequestStatusName.NO_REQUEST, value: ContractRequestStatus.NO_REQUEST.toString() },
];
